<template>
  <div class="md-layout-item md-size-100 my-2 activity-dashaboard">
    <div class="loading-container mr-2 w-100 text-center p-4" v-if="isLoading">
        <md-progress-spinner 
          :md-diameter="80" 
          md-mode="indeterminate" 
          class="text-red bg-red md-red">
        </md-progress-spinner>
      </div>
       <h6>  Mis clases</h6>
          <div class="w-100 text-center customborder" v-if="activitiesWithDate.length == 0 && !isLoading">
             <h5 class="text-secondary p-4">{{$t('nothingtosee')}}</h5>
          </div>
    <!-- Listado de actividades con startDate no nulo -->
    <div v-if="activitiesWithDate.length && !isLoading">
      <div v-for="act in activitiesWithDate" :key="act._id" class="card p-4" :class="isPastDay(act) ? 'bg-grey':''"> 
        <div class="d-inline">           
          <span class="text-secondary" v-if="act.startDate">{{ labelDate(act.startDate) }} {{act.startTime}}hs.</span>
     
          <Activity  
          :myclasses="true"  
          :activity="act" 
          :profile="profile"
          :edit="false" />
          <md-button class="md-btn md-danger md-sm" 
            v-if="(!isPastDay(act) && isClientGym())" 
            @click="deleteClass(act._id,act)">{{$t('unsubscribe')}}</md-button>
        </div>
      </div>
    </div>

    <!-- Listado de actividades con startDate nulo -->
    <div v-if="activitiesWithoutDate.length && !isLoading">
      <div v-for="act in activitiesWithoutDate" :key="act._id" class="card p-4">
        <div class="d-inline">
          <Activity :myclasses="true" :activity="act" :edit="false" 
          :profile="profile" />
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import permissionsMixin from '@/mixins/permissionsMixin';
import { deleteClassAction, getMyClassesAction } from "@/pages/Stablishments/actions";
import Swal from 'sweetalert2';
import { format, isBefore, isToday } from 'date-fns';
import { Activity } from "@/components";
import { getProfileStablishmentsAction } from "@/pages/Stablishments/actions";
import { getMyProfileAction } from "@/pages/Users/actions";

export default {
  name: "myclasses",
  mixins: [permissionsMixin],
  components: {
    Activity
  },
  data() {
    return { 
      isLoading: false,
      activitiesWithDate: [], // Actividades con startDate no nulo
      activitiesWithoutDate: [], // Actividades con startDate nulo
      daysOfWeek: ['Domingo','Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      stablishment: null
    };
  },
  props: { 
    all: Boolean,
    owner: Boolean
  },
  async created(){
    this.isLoading = true;
    await this.getMyProfile();
    await this.getMyClasses();
    await  this.getStablishments();
    this.isLoading = false;
  },
  methods: {

    async getMyProfile(){
      const response = await getMyProfileAction();
      this.profile = response;
      console.log("PROFILE");
      console.log(this.profile);
    },
    // Función para obtener la hora actual en Argentina
    getCurrentTime() {
      const now = new Date();
      // Convertir UTC a Argentina (UTC-3) de manera consistente
      const argentinaOffset = -3 * 60; // -3 horas en minutos
      const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      const argentinaTime = new Date(utc + (argentinaOffset * 60000));
      return argentinaTime;
    },
    async getStablishments(){
      const stablishmentsResponse = await getProfileStablishmentsAction();
      if(stablishmentsResponse.stablishments){
        this.stablishment = stablishmentsResponse.stablishments[0];
      }
    },
    isPastDay(activity) {
      if(!activity || !activity.startDate){
        return false;
      }

      // Obtener la fecha actual en Argentina (UTC-3)
      const now = new Date();
      const argentinaTime = this.getCurrentTime();
      
      // Crear la fecha de la actividad combinando startDate y startTime
      const activityDate = new Date(activity.startDate);
      
      // Si hay startTime, combinarlo con la fecha
      if (activity.startTime) {
        const [hours, minutes] = activity.startTime.split(':').map(Number);
        activityDate.setHours(hours, minutes, 0, 0);
      }
      
      let limitTime = new Date(activityDate);
      
      // If inscriptionBefore exists and is a number, use it as hours
      if (this.stablishment?.businessName?.unnscriptionBefore && !isNaN(this.stablishment.businessName.unnscriptionBefore)) {
        const hoursBefore = parseInt(this.stablishment.businessName.unnscriptionBefore);
        limitTime = new Date(activityDate);
        limitTime.setHours(activityDate.getHours() - hoursBefore);
      }

      return argentinaTime > limitTime;
    },
    isTodayDay(activity) {
      if(!activity || !activity.startDate){
        return false;
      }

      // Obtener la fecha actual en Argentina (UTC-3)
      const now = new Date();
      const argentinaTime = this.getCurrentTime();
      
      // Crear la fecha de la actividad combinando startDate y startTime
      const activityDate = new Date(activity.startDate);
      
      // Si hay startTime, combinarlo con la fecha
      if (activity.startTime) {
        const [hours, minutes] = activity.startTime.split(':').map(Number);
        activityDate.setHours(hours, minutes, 0, 0);
      }
      
      const localDate = new Date(activityDate);
      localDate.setHours(0, 0, 0, 0);
      const today = new Date(argentinaTime);
      today.setHours(0, 0, 0, 0);
      
      return localDate.getTime() === today.getTime();
    },
    async deleteClass(id, activity) {
      // Si la clase ya pasó, no permitir desuscripción
      if (this.isPastDay(activity)) {
        console.log('La clase ya pasó, no se puede cancelar');
        Swal.fire({
          title: 'No puedes cancelar esta clase',
          text: 'Esta clase ya ha pasado.',
          icon: 'warning',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
        });
        return;
      }

      // Si es la clase de hoy, verificar el límite de tiempo de cancelación
      if (this.isTodayDay(activity)) {
        console.log('Es la clase de hoy, verificando límite de cancelación');
        // Obtener la fecha actual en Argentina (UTC-3)
        const now = new Date();
        const argentinaTime = this.getCurrentTime();
        
        // Crear la fecha de la actividad combinando startDate y startTime
        const activityTime = new Date(activity.startDate);
        if (activity.startTime) {
          const [hours, minutes] = activity.startTime.split(':').map(Number);
          activityTime.setHours(hours, minutes, 0, 0);
        }
        
        // Verificar si hay un límite de tiempo de cancelación configurado
        if (this.stablishment?.businessName?.unnscriptionBefore && !isNaN(this.stablishment.businessName.unnscriptionBefore)) {
          const hoursBefore = parseInt(this.stablishment.businessName.unnscriptionBefore);
          const limitTime = new Date(activityTime);
          limitTime.setHours(activityTime.getHours() - hoursBefore);
          
          console.log('Detalles de la comparación:');
          console.log('Hora de la actividad:', activityTime.toLocaleString());
          console.log('Límite de cancelación:', limitTime.toLocaleString());
          console.log('Hora actual (AR):', argentinaTime.toLocaleString());
          console.log('¿Hora actual < Límite?:', argentinaTime < limitTime);
          
          // Si la hora actual es ANTERIOR al límite, permitir la cancelación
          if (argentinaTime < limitTime) {
            console.log('Dentro del límite de tiempo, procediendo con la cancelación');
            // Continuar con la cancelación
          } else {
            console.log('Fuera del límite de tiempo, no se puede cancelar');
            Swal.fire({
              title: 'No puedes cancelar ahora',
              text: `Lo sentimos pero no puedes cancelar la clase cuando faltan menos de ${hoursBefore} horas para que comience. Contactate con nosotros.`,
              icon: 'warning',
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonColor: '#3085d6',
            });
            return;
          }
        }
     
      }

      try {
        console.log('Iniciando proceso de cancelación');
        await deleteClassAction(id, false);
        
        // Primero emitir el evento de eliminación
        this.$emit("deleted");
        
        // Luego refrescar la lista de clases
        await this.getMyClasses();
        
        // Finalmente mostrar el mensaje de éxito
        await Swal.fire({
          title: 'Clase cancelada con éxito',
          icon: 'success',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
        });
      } catch (error) {
        console.error('Error al cancelar la clase:', error);
        await Swal.fire({
          title: 'Error al cancelar la clase',
          text: 'Por favor, intenta nuevamente más tarde.',
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
        });
      }
    },
    labelDate(startDate){
      return format(startDate, 'd') + ' ' + this.$t(format(startDate, 'MMMM')) + ' ' + format(startDate, 'yyyy');
    },
    async getMyClasses(){
    this.isLoading = true;
      const response = await getMyClassesAction(this.all,this.owner);

      // Filtrar actividades según si tienen o no startDate
      let activitiesWithDate = response.data.filter(act => act.startDate);
      let activitiesWithoutDate = response.data.filter(act => !act.startDate);

      // Filtrar actividades recurrentes que tienen una actividad específica relacionada
      activitiesWithoutDate = activitiesWithoutDate.filter(recurringActivity => {
        // Excluir si alguna actividad con fecha tiene como relatedActivity el _id de esta actividad recurrente
        return !activitiesWithDate.some(
          activityWithDate => activityWithDate.relatedActivity === recurringActivity._id
        );
      });

      this.activitiesWithDate = activitiesWithDate;
      this.activitiesWithoutDate = activitiesWithoutDate;

    this.isLoading = false;
    }
  },
};
</script>

<style>
.bg-grey{ 
  background:#c8c8c8;
}
.activity-dashaboard{
  overflow-y: scroll;
  max-height: 350px;
}
</style>
